import { missingSupabaseVars } from '../lib/config'

const card: React.CSSProperties = {
  maxWidth: 560,
  margin: '10vh auto',
  padding: 32,
  background: '#FFFDF9',
  border: '1px solid #E4DDD2',
  borderRadius: 12,
  fontFamily: 'Inter, system-ui, sans-serif',
  color: '#0B1B33',
}

const code: React.CSSProperties = {
  background: '#EFEAE2',
  padding: '2px 8px',
  borderRadius: 4,
  fontFamily: 'ui-monospace, Menlo, monospace',
  fontSize: 13,
}

/**
 * Rendered instead of crashing when Supabase env vars are absent.
 * (Previously this state threw inside AuthContext -> white screen.)
 */
export function SetupRequired() {
  const missing = missingSupabaseVars()
  return (
    <div style={card} role="alert">
      <p style={{ margin: 0, fontSize: 12, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#9E3F26' }}>
        nMachCRM · setup required
      </p>
      <h1 style={{ fontSize: 25, lineHeight: 1.3, margin: '8px 0 16px' }}>
        The portal needs a Supabase connection before it can start.
      </h1>
      <p style={{ margin: '0 0 8px', color: '#5A6472' }}>
        Missing environment variable{missing.length > 1 ? 's' : ''}:{' '}
        {missing.map((v) => (
          <code key={v} style={code}>{v}</code>
        ))}
      </p>
      <ol style={{ color: '#5A6472', lineHeight: 1.8, paddingLeft: 20 }}>
        <li>
          Copy <code style={code}>.env.example</code> to <code style={code}>.env</code> in the repo root
          (<code style={code}>X:\opencodeapps\nMachCRM</code>).
        </li>
        <li>
          Set <code style={code}>VITE_SUPABASE_URL</code> and <code style={code}>VITE_SUPABASE_ANON_KEY</code> from
          your Supabase project → Settings → API.
        </li>
        <li>
          Apply the migrations in <code style={code}>supabase/migrations/</code> (see README).
        </li>
        <li>
          Restart <code style={code}>npm run dev</code> and refresh this page.
        </li>
      </ol>
      <p style={{ marginTop: 24, fontSize: 13, color: '#5A6472' }}>
        Want the marketing site instead? Run <code style={code}>npm run dev:landing</code>.
      </p>
    </div>
  )
}
